import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesComponent } from './directives.component';
import {ColorBotonDirective} from '../style/color-boton.directive';
import { EstadoCobroDirective } from '../style/estado-cobro.directive';
import { RowColorDirective } from '../style/row-color.directive';
import { DisabledControlDirective } from '../disabled-control.directive';
import { Select2Directive } from '../select2.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  exports:[
    ColorBotonDirective,
    EstadoCobroDirective,
    RowColorDirective,
    DisabledControlDirective,
    Select2Directive
  ],
  declarations:[
    ColorBotonDirective,
    EstadoCobroDirective,
    RowColorDirective,
    DisabledControlDirective,
    Select2Directive
  ]
})
export class DirectivesModule { }
 